import { Link2, X } from "lucide-react";

export const DuplicateReview = ({ dupes, onLinkAll, onLinkPair, onDismiss }) => {
  if (dupes.length === 0) return null;
  return (
    <div className="mb-5 space-y-2" data-testid="dupe-review">
      {dupes.length >= 2 && (
        <div className="flex items-center justify-between rounded-xl border border-amber-300 bg-amber-100/60 p-3">
          <span className="text-sm font-medium text-amber-800">{dupes.length} possible duplicates found</span>
          <button onClick={onLinkAll} data-testid="dupe-link-all-btn" className="inline-flex items-center gap-1 rounded-full bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-amber-700"><Link2 className="h-3 w-3" /> Link all {dupes.length} duplicates</button>
        </div>
      )}
      {dupes.map((p) => (
        <div key={p.pair_id} className="flex flex-wrap items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm" data-testid="dupe-pair">
          <Link2 className="h-4 w-4 shrink-0 text-amber-600" />
          <div className="min-w-0 flex-1">
            <p className="text-amber-800">These look like the same one — link them?</p>
            <p className="truncate text-xs text-amber-600">{p.a.title} · {p.b.title} — {p.reason}</p>
          </div>
          <button onClick={() => onLinkPair(p)} data-testid="dupe-link-btn" className="inline-flex items-center gap-1 rounded-full bg-amber-500 px-3 py-1.5 text-xs font-semibold text-white hover:bg-amber-600"><Link2 className="h-3 w-3" /> Link them</button>
          <button onClick={() => onDismiss(p)} data-testid="dupe-dismiss-btn" aria-label="Not duplicates" className="rounded-full p-1.5 text-amber-500 hover:bg-amber-100"><X className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
};
